import { createPinia, setActivePinia } from "pinia";
const pinia = window.__pt_pinia || createPinia();
window.__pt_pinia = pinia;
setActivePinia(pinia);
export default pinia;